import SaveIcon from '@mui/icons-material/Save';
import { Button,Stack,TextField } from "@mui/material";
import { useMask } from '@react-input/mask';
import { useMutation } from "@tanstack/react-query";
import React,{ useContext,useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { UserContext } from "../../context/UserContext";
import AttToken from "../../helpers/attToken";
import { trackEventMatomo } from "../../helpers/matomo";
import Clients from "../../service/Clients";
import { Form } from "../../StyledComponents/Input/generic";

const clientsService = new Clients();

export default function AddCustomer() {
  const { hierarchyLabel } = useContext(UserContext);
  const [customerName, setCustomerName] = useState("");
  const [phone, setPhone] = useState("");
  const inputRef = useMask({ mask: '(__) ____-_____', replacement: '_' });
  const { t } = useTranslation('translation');

  const { mutate, isPending } = useMutation({
    mutationKey: ['ADD_NEW_CUSTOMER'],
    mutationFn: async () => {
      try {
        const token = await AttToken();
        if (!token) throw new Error('Token not found');
        const promise = toast.promise(async () => {
          const body = { ...token };
          const response: { cliente: ClientTypes } = await clientsService.createClient(body, {
            contato: phone,
            dataCadastro: Date.now(),
            empresa: body.userEmpresa,
            foto: ' ',
            listaGerencia: [],
            nome: customerName,
            responsavel: ' ',
            status: 'ativo',
            locais: [],
            tags: [],
          });
          if (!response || !response.cliente) throw new Error('No client created');
          return response.cliente;
        }, {
          pending: t('toast.creatingNew', { label: hierarchyLabel.cliente }),
          success: t('toast.createdSuccess', { label: hierarchyLabel.cliente }),
          error: t('toast.errorCreating', { label: hierarchyLabel.cliente }),
        }, {
          toastId: 'create',
        });
        return promise;
      } catch (error) {
        console.error('Error creating client:', error);
        throw error;
      }
    },
    onSuccess: () => {
      trackEventMatomo('gestão de clientes', 'sucesso', 'criação', 'cliente criado');
      setCustomerName('');
      setPhone('');
    },
    onError: () => trackEventMatomo('gestão de clientes', 'erro', 'criação', 'falha ao criar cliente'),
  });

  return (
    <Form onSubmit={(e: React.SyntheticEvent) => {
      e.preventDefault();
      mutate();
    }
    }>
      <Stack width='100%' direction='column' justifyContent='flex-start' alignItems='flex-start' spacing={2}>
        <TextField
          onClick={() => trackEventMatomo('Adicionar cliente', 'click', 'input', 'editar valor')}
          label={t('name')}
          fullWidth
          slotProps={{
            htmlInput: {
              maxLength: 40
            }
          }}
          value={customerName}
          type="text"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCustomerName(e.target.value)}
        />
        <TextField
          onClick={() => trackEventMatomo('Adicionar cliente', 'click', 'input', 'editar valor')}
          label={t('tel')}
          inputRef={inputRef}
          type='tel'
          fullWidth
          slotProps={{
            htmlInput: {
              maxLength: 40
            }
          }}
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
        <Button
          endIcon={<SaveIcon />}
          onClick={() => trackEventMatomo('Adicionar cliente', 'click', 'button', 'salvar')}
          disabled={customerName === '' || phone.length < 14 || isPending}
          className="button is-success"
          type="submit"
        >
          {t('save')}
        </Button>
      </Stack>
    </Form>
  );
}
